import { Module } from 'vuex';
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { RootState } from '../../types';
import { StoreState } from './types';

const state: StoreState = {
  screenClusters: [],
  storeCampaigns: [],
};

export const StoreModule: Module<StoreState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
